module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.10141a9d.eot";